import styled from 'vue-styled-components'
const WrapperProps = {
  position: {},
  isActiveWidget: false,
}

const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 7;
&::after {
position: absolute;
top: 0;
  content: '';
  width: 100%;
  height: 100%;
  border: ${({isActiveWidget}) => isActiveWidget ? '1px solid #A9A9A9' : '4px solid #12A9FF'};
  z-index: 5;
}
.add-widget {
  position: absolute;
  pointer-events: auto;
  color:  #12A9FF;
  background-color: white;
  border-radius: 50%;
  height: 20px;
  width: 20px;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  &.bottom {
    bottom: -10px;
    left: 0;
    right: 0;
    margin: auto;
  }
  &.top {
    top: -10px;
    left: 0;
    right: 0;
    margin: auto;
  }
}

.lbl-name {
  z-index: 1;
  bottom: 100%;
}
.slide-container-tool {
  z-index: 1;
  bottom: 100%;
}

&.top {
  .slide-container-tool {
    z-index: 1;
    bottom: 100%;
  }
}
&.bottom {
  .slide-container-tool {
    z-index: 1;
    top: 100%;
  }
}

`

const Legend = styled('div')`
pointer-events: auto;
position: absolute;
width: fit-content;
left: 0px;
/* border-radius: 0px 0px 4px 0px; */
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;

&.disabled {
  background-color: #A9A9A9;
  border: 1px solid #A9A9A9;
  color: white;
}
&.lbl-hover:hover {
  background-color: #F4FCFF;
  border: 1px solid #12A9FF;
  color: #12A9FF;
  cursor: pointer;
}
`
const SlideContainerTool = styled.div`
 pointer-events: auto;
position: absolute;
width: fit-content;
padding: 2px;
right: 0;
/* border-radius: 0px 0px 4px 0px; */
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;
border-radius: 0px 0px 0px 0px;

&.disabled {
  background-color: #A9A9A9;
  border-color: #A9A9A9;
  > div {
    &:hover {
      background-color: unset
    }
  }
}
`
const SlideContainerAction = styled.div`
padding: 0px 2px;
height: 18px;
font-size: 1.2em;
&:hover {
  background-color: #0B77B5;
  border-radius: 2px;
  cursor: pointer;
}
`
export {
  Wrapper,
  Legend,
  SlideContainerTool,
  SlideContainerAction,
}